import { render, staticRenderFns } from "./JourneyForm.vue?vue&type=template&id=429a8d82&scoped=true"
import script from "./JourneyForm.vue?vue&type=script&lang=js"
export * from "./JourneyForm.vue?vue&type=script&lang=js"
import style0 from "./JourneyForm.vue?vue&type=style&index=0&id=429a8d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429a8d82",
  null
  
)

export default component.exports